import { ApplicationConfig, inject, LOCALE_ID, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideSharedConfig, provideTranslocoConfig } from '@pf/shared/config';
import { environment } from '../environments/environment';
import { provideTransloco, TranslocoService } from '@jsverse/transloco';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { AuthConfig } from './app.auth.config';
import { provideAuth, withAppInitializerAuthCheck } from 'angular-auth-oidc-client';
import { registerLocaleData } from '@angular/common';
import { authInterceptor } from '@pf/shared/data';
import { firstValueFrom } from 'rxjs';
import { provideAnimations } from '@angular/platform-browser/animations';
import localeNl from '@angular/common/locales/nl';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';

registerLocaleData(localeNl, 'nl-NL');

export function preloadTranslation(transloco: TranslocoService) {
  return function () {
    transloco.setActiveLang('nl');
    return firstValueFrom(transloco.load('nl'));
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideTransloco(provideTranslocoConfig),
    provideHttpClient(withXhr(), withInterceptors([authInterceptor])),
    provideSharedConfig(environment),
    provideAnimations(),
    provideTranslocoMessageformat({ locales: 'nl-NL' }),
    provideAuth({ config: AuthConfig }, withAppInitializerAuthCheck()),
    { provide: LOCALE_ID, useValue: 'nl-NL' },
    provideAppInitializer(() => {
      const initializerFn = preloadTranslation(inject(TranslocoService));
      return initializerFn();
    }),
  ],
};
